import { render, staticRenderFns } from "./MessageFunctionalities.vue?vue&type=template&id=c358a326&scoped=true&"
import script from "./MessageFunctionalities.vue?vue&type=script&lang=js&"
export * from "./MessageFunctionalities.vue?vue&type=script&lang=js&"
import style0 from "./MessageFunctionalities.vue?vue&type=style&index=0&id=c358a326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c358a326",
  null
  
)

export default component.exports